import type React from 'react';

const ExpandedChatAnimationStyles: React.FC = () => {
    const dockedShellRadius = 'var(--rw-radius-shell-panel) var(--rw-radius-shell-panel) 0 0';
    const fullShellRadius = 'var(--rw-radius-shell-panel)';

    return (
        <style>
            {`
                /* Default (centered) animations */
                @keyframes maximizeIn {
                    0% {
                        opacity: 0;
                        transform: translateX(-50%) translateY(-20px) scale(0.1);
                        border-radius: 50px;
                    }
                    30% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 1;
                        transform: translateX(-50%) translateY(0px) scale(1);
                        border-radius: ${dockedShellRadius};
                    }
                }

                @keyframes minimizeOut {
                    0% {
                        opacity: 1;
                        transform: translateX(-50%) translateY(0px) scale(1);
                        border-radius: ${dockedShellRadius};
                    }
                    70% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                        transform: translateX(-50%) translateY(-20px) scale(0.1);
                        border-radius: 50px;
                    }
                }

                .maximizeIn {
                    animation: maximizeIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                    opacity: 0;
                    transform-origin: center bottom;
                }

                .minimizeOut {
                    animation: minimizeOut 0.4s cubic-bezier(0.55, 0.055, 0.675, 0.19) forwards;
                    opacity: 1;
                    transform-origin: center bottom;
                }

                /* Copilot (right-side panel) animations.
                   Mirrors the main widget's appear-then-unfold feel: the panel slides
                   in from off-screen-right (appear), then settles to scale 1 (unfold). */
                @keyframes maximizeInCopilot {
                    0% {
                        opacity: 0;
                        transform: translateX(calc(100% + 4rem)) scale(0.9);
                        border-radius: ${fullShellRadius};
                    }
                    30% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 1;
                        transform: translateX(0) scale(1);
                        border-radius: ${fullShellRadius};
                    }
                }

                @keyframes minimizeOutCopilot {
                    0% {
                        opacity: 1;
                        transform: translateX(0) scale(1);
                        border-radius: ${fullShellRadius};
                    }
                    70% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                        transform: translateX(20px) scale(0.9);
                        border-radius: ${fullShellRadius};
                    }
                }

                .maximizeInCopilot {
                    animation: maximizeInCopilot 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
                    opacity: 0;
                    transform-origin: right center;
                }

                .minimizeOutCopilot {
                    animation: minimizeOutCopilot 0.4s cubic-bezier(0.55, 0.055, 0.675, 0.19) forwards;
                    opacity: 1;
                    transform-origin: right center;
                }

            `}
        </style>
    );
};

export default ExpandedChatAnimationStyles;
